// GENERATED by @platform/contracts from specs/assistant/main.tsp. Do not edit; run `pnpm generate`.
/* eslint-disable */
import { z } from 'zod';
/** Below 80% of every limit, at 80% or more of one, or at a limit (calls are refused). */
export const AllowanceState = z.enum(['ok', 'warning', 'stopped']);
/** What a call is for: `fast` (short, cheap answers) or `standard` (everyday work, the most capable class). */
export const ModelClass = z.enum(['fast', 'standard']);
/** The workspace this calendar month, the workspace today, or one person this calendar month. */
export const LimitScope = z.enum(['month', 'day', 'memberMonth']);
/** One limit of the plan and what has been spent against it. */
export const LimitUse = z.object({
    scope: LimitScope,
    period: z.string(),
    spentMicroUsd: z.int().min(0),
    limitMicroUsd: z.int().min(0),
    percentUsed: z.int32().min(0),
    state: AllowanceState,
});
/** The plan's limits for the assistant and where the workspace (and the caller) stand. */
export const Allowance = z.object({
    state: AllowanceState,
    models: z.array(ModelClass),
    limits: z.array(LimitUse),
    memberMonthlyLimitMicroUsd: z.int().min(0).optional(),
});
/** ULID-style opaque identifier for records. */
export const RecordId = z.string().regex(/^[0-9A-HJKMNP-TV-Z]{26}$/);
/** Cognito subject (the identity's stable id). */
export const Sub = z.string().min(1).max(128);
/** Why the reply ended: it was complete, it hit `maxTokens`, the model declined, or anything else. */
export const StopReason = z.enum(['end', 'length', 'refused', 'other']);
/** Tokens a call used, as the provider counted them. */
export const TokenUsage = z.object({
    inputTokens: z.int32().min(0),
    outputTokens: z.int32().min(0),
    cacheReadTokens: z.int32().min(0),
    cacheWriteTokens: z.int32().min(0),
});
/** One call, for the itemised list. */
export const CallRecord = z.object({
    callId: RecordId,
    at: z.iso.datetime({ offset: true }),
    sub: Sub,
    model: ModelClass,
    stopReason: StopReason,
    usage: TokenUsage,
    costMicroUsd: z.int().min(0),
});
/** How much the model thinks before it answers. More effort costs more and takes longer. */
export const Effort = z.enum(['low', 'medium', 'high']);
/** One person's totals this calendar month. */
export const MemberUsage = z.object({
    sub: Sub,
    calls: z.int32().min(0),
    spentMicroUsd: z.int().min(0),
});
export const MessageRole = z.enum(['user', 'assistant']);
/** One turn of the conversation. */
export const Message = z.object({ role: MessageRole, content: z.string().min(1).max(200000) });
export const MessageRequest = z.object({
    model: ModelClass,
    system: z.string().max(100000).optional(),
    messages: z.array(Message).min(1).max(100),
    maxTokens: z.int32().min(1).max(8192).default(1024),
    effort: Effort.default('low'),
});
export const MessageResult = z.object({
    callId: RecordId,
    model: ModelClass,
    text: z.string(),
    stopReason: StopReason,
    usage: TokenUsage,
    costMicroUsd: z.int().min(0),
    allowance: Allowance,
});
/** Machine-readable error codes. Never say whether a resource exists to a caller outside its tenant. */
export const ErrorCode = z.enum([
    'validation',
    'unauthenticated',
    'forbidden',
    'notFound',
    'conflict',
    'rateLimited',
    'internal',
]);
export const ErrorDetail = z.object({ path: z.string().optional(), message: z.string() });
/** The one error shape. Sent with the matching HTTP status. */
export const ErrorResponse = z.object({
    code: ErrorCode,
    message: z.string(),
    requestId: z.string(),
    details: z.array(ErrorDetail).optional(),
});
/** Tenant identifier. The control plane's own resources use the literal `platform`. */
export const TenantId = z.string().regex(/^[a-z0-9][a-z0-9-]{1,62}$/);
/** Totals over one period. */
export const UsageTotals = z.object({
    period: z.string(),
    calls: z.int32().min(0),
    inputTokens: z.int().min(0),
    outputTokens: z.int().min(0),
    spentMicroUsd: z.int().min(0),
});
export const UsageReport = z.object({
    allowance: Allowance.optional(),
    month: UsageTotals,
    today: UsageTotals,
    members: z.array(MemberUsage),
    recent: z.array(CallRecord),
});
/** One validator set per operation, keyed by operationId. Same order as the route manifest. */
export const operations = {
    Messages_create: {
        operationId: 'Messages_create',
        method: 'POST',
        path: '/messages',
        params: z.object({}),
        query: z.object({}),
        body: MessageRequest,
        responses: {
            '200': z.object({ tenantId: TenantId, requestId: z.string(), data: MessageResult }),
            '400': ErrorResponse,
            '401': ErrorResponse,
            '403': ErrorResponse,
            '404': ErrorResponse,
            '429': ErrorResponse,
        },
    },
    Usage_get: {
        operationId: 'Usage_get',
        method: 'GET',
        path: '/usage',
        params: z.object({}),
        query: z.object({}),
        responses: {
            '200': z.object({ tenantId: TenantId, requestId: z.string(), data: UsageReport }),
            '400': ErrorResponse,
            '401': ErrorResponse,
            '403': ErrorResponse,
            '404': ErrorResponse,
        },
    },
};
//# sourceMappingURL=schemas.js.map